/* global axios */

import ApiClient from './ApiClient';

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey }) {
    const url = searchKey ? `${this.url}?search=${searchKey}` : this.url;
    return axios.get(url);
  }

  create(data) {
    return axios.post(this.url, this.buildPayload(data));
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, this.buildPayload(data));
  }

  // eslint-disable-next-line class-methods-use-this
  buildPayload({ short_code, content, attachment, remove_attachment }) {
    if (!attachment && !remove_attachment) {
      return { short_code, content };
    }

    const formData = new FormData();
    formData.append('canned_response[short_code]', short_code);
    formData.append('canned_response[content]', content);
    if (attachment) {
      formData.append('canned_response[attachment]', attachment);
    }
    if (remove_attachment) {
      formData.append('canned_response[remove_attachment]', true);
    }
    return formData;
  }
}

export default new CannedResponse();
